export default __webpack_public_path__ + "static/media/ff6d56271c739d880874c0e2e93310c3.png";